export const mediaKitTranslations = {
  en: {
    "mediaKit.seoTitle": "LUKKEY Media Kit | Brand and Design Assets",
    "mediaKit.seoDescription":
      "Official LUKKEY brand, product, design, and documentation assets for partners and approved external use.",
    "mediaKit.badge": "Media Kit",
    "mediaKit.heroTitle": "Ready when needed.",
    "mediaKit.heroSubtitle": "Logos. Product images. Brand documents.",
    "mediaKit.allAssets": "All assets",
    "mediaKit.pickOne": "Pick one",
    "mediaKit.files": "files",
    "mediaKit.fileCount": "{{count}} files",
    "mediaKit.modules": "{{count}} modules",
    "mediaKit.chooseAssets": "Choose your assets.",
    "mediaKit.download": "Download",
    "mediaKit.directoryLabel": "File directory",
    "mediaKit.showDirectory": "Show file directory",
    "mediaKit.closeDirectory": "Close file directory",
    "mediaKit.noDirectoryFiles": "No files listed yet.",
    "mediaKit.filesPending": "Files pending",
    "mediaKit.empty": "Media kit files are being prepared.",
    "mediaKit.module.brand-logos.title": "Brand Elements",
    "mediaKit.module.product-images.title": "Product Images",
    "mediaKit.module.brand-documents.title": "Brand Documents",
  },
  zh: {
    "mediaKit.seoTitle": "LUKKEY 媒体资料包 | 品牌与设计资料",
    "mediaKit.seoDescription":
      "LUKKEY 官方品牌、产品、设计与文档资料，供合作伙伴及获准的外部发布使用。",
    "mediaKit.badge": "媒体资料包",
    "mediaKit.heroTitle": "随时可用。",
    "mediaKit.heroSubtitle": "Logo、产品图片、品牌文件。",
    "mediaKit.allAssets": "全部素材",
    "mediaKit.pickOne": "选择模块",
    "mediaKit.files": "文件",
    "mediaKit.fileCount": "{{count}} 个文件",
    "mediaKit.modules": "{{count}} 个模块",
    "mediaKit.chooseAssets": "选择所需素材。",
    "mediaKit.download": "下载",
    "mediaKit.directoryLabel": "文件目录",
    "mediaKit.showDirectory": "查看文件目录",
    "mediaKit.closeDirectory": "关闭文件目录",
    "mediaKit.noDirectoryFiles": "暂无文件列表。",
    "mediaKit.filesPending": "文件准备中",
    "mediaKit.empty": "媒体资料文件正在准备中。",
    "mediaKit.module.brand-logos.title": "品牌元素",
    "mediaKit.module.product-images.title": "产品图片",
    "mediaKit.module.brand-documents.title": "品牌文件",
  },
  "zh-TW": {
    "mediaKit.seoTitle": "LUKKEY 媒體資料包 | 品牌與設計資料",
    "mediaKit.seoDescription":
      "LUKKEY 官方品牌、產品、設計與文件資料，供合作夥伴及核准的外部發布使用。",
    "mediaKit.badge": "媒體資料包",
    "mediaKit.heroTitle": "需要時即可使用。",
    "mediaKit.heroSubtitle": "Logo、產品圖片、品牌文件。",
    "mediaKit.allAssets": "全部素材",
    "mediaKit.pickOne": "選擇模組",
    "mediaKit.files": "檔案",
    "mediaKit.fileCount": "{{count}} 個檔案",
    "mediaKit.modules": "{{count}} 個模組",
    "mediaKit.chooseAssets": "選擇所需素材。",
    "mediaKit.download": "下載",
    "mediaKit.directoryLabel": "檔案目錄",
    "mediaKit.showDirectory": "查看檔案目錄",
    "mediaKit.closeDirectory": "關閉檔案目錄",
    "mediaKit.noDirectoryFiles": "暫無檔案列表。",
    "mediaKit.filesPending": "檔案準備中",
    "mediaKit.empty": "媒體資料檔案正在準備中。",
    "mediaKit.module.brand-logos.title": "品牌元素",
    "mediaKit.module.product-images.title": "產品圖片",
    "mediaKit.module.brand-documents.title": "品牌文件",
  },
  fr: {
    "mediaKit.seoTitle": "Kit média LUKKEY | Ressources marque et design",
    "mediaKit.seoDescription":
      "Ressources officielles de marque, produit, design et documentation LUKKEY pour les partenaires et publications externes approuvées.",
    "mediaKit.badge": "Kit média",
    "mediaKit.heroTitle": "Prêt au besoin.",
    "mediaKit.heroSubtitle": "Logos. Images produit. Documents de marque.",
    "mediaKit.allAssets": "Tous les éléments",
    "mediaKit.pickOne": "Choisir",
    "mediaKit.files": "fichiers",
    "mediaKit.fileCount": "{{count}} fichiers",
    "mediaKit.modules": "{{count}} modules",
    "mediaKit.chooseAssets": "Choisissez vos ressources.",
    "mediaKit.download": "Télécharger",
    "mediaKit.directoryLabel": "Répertoire des fichiers",
    "mediaKit.showDirectory": "Afficher le répertoire des fichiers",
    "mediaKit.closeDirectory": "Fermer le répertoire des fichiers",
    "mediaKit.noDirectoryFiles": "Aucun fichier répertorié pour le moment.",
    "mediaKit.filesPending": "Fichiers en attente",
    "mediaKit.empty": "Les fichiers du kit média sont en préparation.",
    "mediaKit.module.brand-logos.title": "Éléments de marque",
    "mediaKit.module.product-images.title": "Images produit",
    "mediaKit.module.brand-documents.title": "Documents de marque",
  },
  es: {
    "mediaKit.seoTitle": "Kit de medios LUKKEY | Recursos de marca y prensa",
    "mediaKit.seoDescription":
      "Recursos oficiales de marca, producto y prensa de LUKKEY para medios, socios y publicaciones externas aprobadas.",
    "mediaKit.badge": "Kit de medios",
    "mediaKit.heroTitle": "Listo cuando se necesite.",
    "mediaKit.heroSubtitle": "Logos. Imágenes de producto. Archivos de prensa.",
    "mediaKit.allAssets": "Todos los recursos",
    "mediaKit.pickOne": "Elegir uno",
    "mediaKit.files": "archivos",
    "mediaKit.fileCount": "{{count}} archivos",
    "mediaKit.modules": "{{count}} módulos",
    "mediaKit.chooseAssets": "Elige tus recursos.",
    "mediaKit.download": "Descargar",
    "mediaKit.directoryLabel": "Directorio de archivos",
    "mediaKit.showDirectory": "Mostrar directorio de archivos",
    "mediaKit.closeDirectory": "Cerrar directorio de archivos",
    "mediaKit.noDirectoryFiles": "Aún no hay archivos listados.",
    "mediaKit.filesPending": "Archivos pendientes",
    "mediaKit.empty": "Los archivos del kit de medios se están preparando.",
    "mediaKit.module.brand-logos.title": "Elementos de marca",
    "mediaKit.module.product-images.title": "Imágenes de producto",
    "mediaKit.module.brand-documents.title": "Documentos de marca",
  },
  ar: {
    "mediaKit.seoTitle": "حزمة LUKKEY الإعلامية | أصول العلامة والصحافة",
    "mediaKit.seoDescription":
      "أصول LUKKEY الرسمية للعلامة والمنتج والصحافة للاستخدام الإعلامي والشركاء والنشر الخارجي المعتمد.",
    "mediaKit.badge": "الحزمة الإعلامية",
    "mediaKit.heroTitle": "جاهزة عند الحاجة.",
    "mediaKit.heroSubtitle": "الشعارات. صور المنتج. ملفات الصحافة.",
    "mediaKit.allAssets": "كل الأصول",
    "mediaKit.pickOne": "اختر واحدًا",
    "mediaKit.files": "ملفات",
    "mediaKit.fileCount": "{{count}} ملفات",
    "mediaKit.modules": "{{count}} وحدات",
    "mediaKit.chooseAssets": "اختر الأصول المطلوبة.",
    "mediaKit.download": "تنزيل",
    "mediaKit.directoryLabel": "دليل الملفات",
    "mediaKit.showDirectory": "عرض دليل الملفات",
    "mediaKit.closeDirectory": "إغلاق دليل الملفات",
    "mediaKit.noDirectoryFiles": "لا توجد ملفات مدرجة بعد.",
    "mediaKit.filesPending": "الملفات قيد الإعداد",
    "mediaKit.empty": "يتم إعداد ملفات الحزمة الإعلامية.",
    "mediaKit.module.brand-logos.title": "عناصر العلامة",
    "mediaKit.module.product-images.title": "صور المنتج",
    "mediaKit.module.brand-documents.title": "مستندات العلامة",
  },
  ja: {
    "mediaKit.seoTitle": "LUKKEY メディアキット | ブランド・プレス素材",
    "mediaKit.seoDescription":
      "メディア、パートナー、承認済みの外部掲載向けの LUKKEY 公式ブランド、製品、プレス素材です。",
    "mediaKit.badge": "メディアキット",
    "mediaKit.heroTitle": "必要なときにすぐ使えます。",
    "mediaKit.heroSubtitle": "ロゴ。製品画像。プレス資料。",
    "mediaKit.allAssets": "すべての素材",
    "mediaKit.pickOne": "選択する",
    "mediaKit.files": "ファイル",
    "mediaKit.fileCount": "{{count}} 件のファイル",
    "mediaKit.modules": "{{count}} 件のモジュール",
    "mediaKit.chooseAssets": "必要な素材を選択。",
    "mediaKit.download": "ダウンロード",
    "mediaKit.directoryLabel": "ファイル一覧",
    "mediaKit.showDirectory": "ファイル一覧を表示",
    "mediaKit.closeDirectory": "ファイル一覧を閉じる",
    "mediaKit.noDirectoryFiles": "まだファイルは表示されていません。",
    "mediaKit.filesPending": "準備中",
    "mediaKit.empty": "メディアキットのファイルを準備中です。",
    "mediaKit.module.brand-logos.title": "ブランド要素",
    "mediaKit.module.product-images.title": "製品画像",
    "mediaKit.module.brand-documents.title": "ブランド資料",
  },
  ru: {
    "mediaKit.seoTitle": "Медиакит LUKKEY | Материалы бренда и прессы",
    "mediaKit.seoDescription":
      "Официальные материалы бренда, продукта и прессы LUKKEY для СМИ, партнеров и одобренных внешних публикаций.",
    "mediaKit.badge": "Медиакит",
    "mediaKit.heroTitle": "Готово, когда нужно.",
    "mediaKit.heroSubtitle": "Логотипы. Изображения продукта. документы дизайна.",
    "mediaKit.allAssets": "Все материалы",
    "mediaKit.pickOne": "Выбрать",
    "mediaKit.files": "файлы",
    "mediaKit.fileCount": "{{count}} файлов",
    "mediaKit.modules": "{{count}} модулей",
    "mediaKit.chooseAssets": "Выберите материалы.",
    "mediaKit.download": "Скачать",
    "mediaKit.directoryLabel": "Каталог файлов",
    "mediaKit.showDirectory": "Показать каталог файлов",
    "mediaKit.closeDirectory": "Закрыть каталог файлов",
    "mediaKit.noDirectoryFiles": "Файлы пока не указаны.",
    "mediaKit.filesPending": "Файлы готовятся",
    "mediaKit.empty": "Файлы медиакита готовятся.",
    "mediaKit.module.brand-logos.title": "Элементы бренда",
    "mediaKit.module.product-images.title": "Изображения продукта",
    "mediaKit.module.brand-documents.title": "Документы бренда",
  },
  ko: {
    "mediaKit.seoTitle": "LUKKEY 미디어 키트 | 브랜드 및 디자인 자료",
    "mediaKit.seoDescription":
      "파트너 및 승인된 외부 게시용 LUKKEY 공식 브랜드, 제품, 디자인 및 문서 자료입니다.",
    "mediaKit.badge": "미디어 키트",
    "mediaKit.heroTitle": "필요할 때 바로 사용.",
    "mediaKit.heroSubtitle": "로고. 제품 이미지. 브랜드 문서.",
    "mediaKit.allAssets": "전체 자료",
    "mediaKit.pickOne": "하나 선택",
    "mediaKit.files": "파일",
    "mediaKit.fileCount": "파일 {{count}}개",
    "mediaKit.modules": "모듈 {{count}}개",
    "mediaKit.chooseAssets": "필요한 자료를 선택하세요.",
    "mediaKit.download": "다운로드",
    "mediaKit.directoryLabel": "파일 디렉터리",
    "mediaKit.showDirectory": "파일 디렉터리 보기",
    "mediaKit.closeDirectory": "파일 디렉터리 닫기",
    "mediaKit.noDirectoryFiles": "아직 표시된 파일이 없습니다.",
    "mediaKit.filesPending": "파일 준비 중",
    "mediaKit.empty": "미디어 키트 파일을 준비 중입니다.",
    "mediaKit.module.brand-logos.title": "브랜드 요소",
    "mediaKit.module.product-images.title": "제품 이미지",
    "mediaKit.module.brand-documents.title": "브랜드 문서",
  },
  pt: {
    "mediaKit.seoTitle": "Media kit LUKKEY | Ativos de marca e imprensa",
    "mediaKit.seoDescription":
      "Ativos oficiais de marca, produto e imprensa da LUKKEY para media, parceiros e publicações externas aprovadas.",
    "mediaKit.badge": "Media kit",
    "mediaKit.heroTitle": "Pronto quando necessário.",
    "mediaKit.heroSubtitle": "Logótipos. Imagens de produto. Ficheiros de imprensa.",
    "mediaKit.allAssets": "Todos os ativos",
    "mediaKit.pickOne": "Escolher",
    "mediaKit.files": "ficheiros",
    "mediaKit.fileCount": "{{count}} ficheiros",
    "mediaKit.modules": "{{count}} módulos",
    "mediaKit.chooseAssets": "Escolha os seus ativos.",
    "mediaKit.download": "Transferir",
    "mediaKit.directoryLabel": "Diretório de ficheiros",
    "mediaKit.showDirectory": "Mostrar diretório de ficheiros",
    "mediaKit.closeDirectory": "Fechar diretório de ficheiros",
    "mediaKit.noDirectoryFiles": "Ainda não há ficheiros listados.",
    "mediaKit.filesPending": "Ficheiros pendentes",
    "mediaKit.empty": "Os ficheiros do media kit estão a ser preparados.",
    "mediaKit.module.brand-logos.title": "Elementos da marca",
    "mediaKit.module.product-images.title": "Imagens de produto",
    "mediaKit.module.brand-documents.title": "Documentos de marca",
  },
  "pt-BR": {
    "mediaKit.seoTitle": "Media kit LUKKEY | Ativos de marca e imprensa",
    "mediaKit.seoDescription":
      "Ativos oficiais de marca, produto e imprensa da LUKKEY para mídia, parceiros e publicações externas aprovadas.",
    "mediaKit.badge": "Media kit",
    "mediaKit.heroTitle": "Pronto quando precisar.",
    "mediaKit.heroSubtitle": "Logos. Imagens de produto. Arquivos de imprensa.",
    "mediaKit.allAssets": "Todos os ativos",
    "mediaKit.pickOne": "Escolher",
    "mediaKit.files": "arquivos",
    "mediaKit.fileCount": "{{count}} arquivos",
    "mediaKit.modules": "{{count}} módulos",
    "mediaKit.chooseAssets": "Escolha seus ativos.",
    "mediaKit.download": "Baixar",
    "mediaKit.directoryLabel": "Diretório de arquivos",
    "mediaKit.showDirectory": "Mostrar diretório de arquivos",
    "mediaKit.closeDirectory": "Fechar diretório de arquivos",
    "mediaKit.noDirectoryFiles": "Ainda não há arquivos listados.",
    "mediaKit.filesPending": "Arquivos pendentes",
    "mediaKit.empty": "Os arquivos do media kit estão sendo preparados.",
    "mediaKit.module.brand-logos.title": "Elementos da marca",
    "mediaKit.module.product-images.title": "Imagens de produto",
    "mediaKit.module.brand-documents.title": "Documentos de marca",
  },
  it: {
    "mediaKit.seoTitle": "Media kit LUKKEY | Risorse brand e design",
    "mediaKit.seoDescription":
      "Risorse ufficiali LUKKEY per brand, prodotto, design e documentazione destinate a partner e pubblicazioni esterne approvate.",
    "mediaKit.badge": "Media kit",
    "mediaKit.heroTitle": "Pronto quando serve.",
    "mediaKit.heroSubtitle": "Loghi. Immagini prodotto. Documenti di brand.",
    "mediaKit.allAssets": "Tutte le risorse",
    "mediaKit.pickOne": "Scegli",
    "mediaKit.files": "file",
    "mediaKit.fileCount": "{{count}} file",
    "mediaKit.modules": "{{count}} moduli",
    "mediaKit.chooseAssets": "Scegli le risorse.",
    "mediaKit.download": "Scarica",
    "mediaKit.directoryLabel": "Directory dei file",
    "mediaKit.showDirectory": "Mostra directory dei file",
    "mediaKit.closeDirectory": "Chiudi directory dei file",
    "mediaKit.noDirectoryFiles": "Nessun file ancora elencato.",
    "mediaKit.filesPending": "File in preparazione",
    "mediaKit.empty": "I file del media kit sono in preparazione.",
    "mediaKit.module.brand-logos.title": "Elementi del brand",
    "mediaKit.module.product-images.title": "Immagini prodotto",
    "mediaKit.module.brand-documents.title": "Documenti di brand",
  },
  de: {
    "mediaKit.seoTitle": "LUKKEY Media Kit | Marken- und Designmaterial",
    "mediaKit.seoDescription":
      "Offizielle LUKKEY Marken-, Produkt-, Design- und Dokumentationsmaterialien für Partner und freigegebene externe Veröffentlichungen.",
    "mediaKit.badge": "Media Kit",
    "mediaKit.heroTitle": "Bereit, wenn gebraucht.",
    "mediaKit.heroSubtitle": "Logos. Produktbilder. Markendokumente.",
    "mediaKit.allAssets": "Alle Assets",
    "mediaKit.pickOne": "Auswählen",
    "mediaKit.files": "Dateien",
    "mediaKit.fileCount": "{{count}} Dateien",
    "mediaKit.modules": "{{count}} Module",
    "mediaKit.chooseAssets": "Assets auswählen.",
    "mediaKit.download": "Herunterladen",
    "mediaKit.directoryLabel": "Dateiverzeichnis",
    "mediaKit.showDirectory": "Dateiverzeichnis anzeigen",
    "mediaKit.closeDirectory": "Dateiverzeichnis schließen",
    "mediaKit.noDirectoryFiles": "Noch keine Dateien gelistet.",
    "mediaKit.filesPending": "Dateien in Vorbereitung",
    "mediaKit.empty": "Die Media-Kit-Dateien werden vorbereitet.",
    "mediaKit.module.brand-logos.title": "Markenelemente",
    "mediaKit.module.product-images.title": "Produktbilder",
    "mediaKit.module.brand-documents.title": "Markendokumente",
  },
  hi: {
    "mediaKit.seoTitle": "LUKKEY मीडिया किट | ब्रांड और डिज़ाइन सामग्री",
    "mediaKit.seoDescription":
      "पार्टनर और स्वीकृत बाहरी प्रकाशन के लिए LUKKEY की आधिकारिक ब्रांड, उत्पाद, डिज़ाइन और दस्तावेज़ सामग्री।",
    "mediaKit.badge": "मीडिया किट",
    "mediaKit.heroTitle": "ज़रूरत पड़ते ही तैयार।",
    "mediaKit.heroSubtitle": "लोगो। उत्पाद चित्र। ब्रांड दस्तावेज़।",
    "mediaKit.allAssets": "सभी सामग्री",
    "mediaKit.pickOne": "एक चुनें",
    "mediaKit.files": "फ़ाइलें",
    "mediaKit.fileCount": "{{count}} फ़ाइलें",
    "mediaKit.modules": "{{count}} मॉड्यूल",
    "mediaKit.chooseAssets": "अपनी सामग्री चुनें।",
    "mediaKit.download": "डाउनलोड",
    "mediaKit.directoryLabel": "फ़ाइल निर्देशिका",
    "mediaKit.showDirectory": "फ़ाइल निर्देशिका दिखाएं",
    "mediaKit.closeDirectory": "फ़ाइल निर्देशिका बंद करें",
    "mediaKit.noDirectoryFiles": "अभी कोई फ़ाइल सूचीबद्ध नहीं है।",
    "mediaKit.filesPending": "फ़ाइलें तैयार हो रही हैं",
    "mediaKit.empty": "मीडिया किट फ़ाइलें तैयार की जा रही हैं।",
    "mediaKit.module.brand-logos.title": "ब्रांड तत्व",
    "mediaKit.module.product-images.title": "उत्पाद चित्र",
    "mediaKit.module.brand-documents.title": "ब्रांड दस्तावेज़",
  },
  mn: {
    "mediaKit.seoTitle": "LUKKEY медиа кит | Брэнд ба дизайны материал",
    "mediaKit.seoDescription":
      "Түншүүд болон зөвшөөрөгдсөн нийтлэлд зориулсан LUKKEY-ийн албан ёсны брэнд, бүтээгдэхүүн, дизайн болон баримт бичгийн материал.",
    "mediaKit.badge": "Медиа кит",
    "mediaKit.heroTitle": "Хэрэгтэй үед бэлэн.",
    "mediaKit.heroSubtitle": "Лого. Бүтээгдэхүүний зураг. Хэвлэлийн файл.",
    "mediaKit.allAssets": "Бүх материал",
    "mediaKit.pickOne": "Сонгох",
    "mediaKit.files": "файл",
    "mediaKit.fileCount": "{{count}} файл",
    "mediaKit.modules": "{{count}} модуль",
    "mediaKit.chooseAssets": "Материалаа сонгоно уу.",
    "mediaKit.download": "Татах",
    "mediaKit.directoryLabel": "Файлын лавлах",
    "mediaKit.showDirectory": "Файлын лавлахыг харуулах",
    "mediaKit.closeDirectory": "Файлын лавлахыг хаах",
    "mediaKit.noDirectoryFiles": "Одоогоор файл жагсаагүй байна.",
    "mediaKit.filesPending": "Файлууд бэлтгэгдэж байна",
    "mediaKit.empty": "Медиа китийн файлууд бэлтгэгдэж байна.",
    "mediaKit.module.brand-logos.title": "Брэнд элементүүд",
    "mediaKit.module.product-images.title": "Бүтээгдэхүүний зураг",
    "mediaKit.module.brand-documents.title": "Брэндийн баримт бичиг",
  },
  th: {
    "mediaKit.seoTitle": "มีเดียคิต LUKKEY | สื่อแบรนด์และงานออกแบบ",
    "mediaKit.seoDescription":
      "สื่อแบรนด์ ผลิตภัณฑ์ งานออกแบบ และเอกสารอย่างเป็นทางการของ LUKKEY สำหรับพาร์ทเนอร์และการเผยแพร่ภายนอกที่ได้รับอนุมัติ",
    "mediaKit.badge": "มีเดียคิต",
    "mediaKit.heroTitle": "พร้อมใช้เมื่อจำเป็น",
    "mediaKit.heroSubtitle": "โลโก้ รูปผลิตภัณฑ์ เอกสารแบรนด์",
    "mediaKit.allAssets": "สื่อทั้งหมด",
    "mediaKit.pickOne": "เลือกหนึ่งรายการ",
    "mediaKit.files": "ไฟล์",
    "mediaKit.fileCount": "{{count}} ไฟล์",
    "mediaKit.modules": "{{count}} โมดูล",
    "mediaKit.chooseAssets": "เลือกสื่อที่ต้องการ",
    "mediaKit.download": "ดาวน์โหลด",
    "mediaKit.directoryLabel": "ไดเรกทอรีไฟล์",
    "mediaKit.showDirectory": "ดูไดเรกทอรีไฟล์",
    "mediaKit.closeDirectory": "ปิดไดเรกทอรีไฟล์",
    "mediaKit.noDirectoryFiles": "ยังไม่มีรายการไฟล์",
    "mediaKit.filesPending": "ไฟล์กำลังเตรียม",
    "mediaKit.empty": "กำลังเตรียมไฟล์มีเดียคิต",
    "mediaKit.module.brand-logos.title": "องค์ประกอบแบรนด์",
    "mediaKit.module.product-images.title": "รูปผลิตภัณฑ์",
    "mediaKit.module.brand-documents.title": "เอกสารแบรนด์",
  },
  uk: {
    "mediaKit.seoTitle": "Медіакіт LUKKEY | Матеріали бренду та преси",
    "mediaKit.seoDescription":
      "Офіційні матеріали бренду, продукту та преси LUKKEY для медіа, партнерів і схвалених зовнішніх публікацій.",
    "mediaKit.badge": "Медіакіт",
    "mediaKit.heroTitle": "Готово, коли потрібно.",
    "mediaKit.heroSubtitle": "Логотипи. Зображення продукту. Прес-файли.",
    "mediaKit.allAssets": "Усі матеріали",
    "mediaKit.pickOne": "Вибрати",
    "mediaKit.files": "файли",
    "mediaKit.fileCount": "{{count}} файлів",
    "mediaKit.modules": "{{count}} модулів",
    "mediaKit.chooseAssets": "Оберіть матеріали.",
    "mediaKit.download": "Завантажити",
    "mediaKit.directoryLabel": "Каталог файлів",
    "mediaKit.showDirectory": "Показати каталог файлів",
    "mediaKit.closeDirectory": "Закрити каталог файлів",
    "mediaKit.noDirectoryFiles": "Файли ще не вказані.",
    "mediaKit.filesPending": "Файли готуються",
    "mediaKit.empty": "Файли медіакіту готуються.",
    "mediaKit.module.brand-logos.title": "Елементи бренду",
    "mediaKit.module.product-images.title": "Зображення продукту",
    "mediaKit.module.brand-documents.title": "Документи бренду",
  },
  vi: {
    "mediaKit.seoTitle": "Bộ media kit LUKKEY | Tài sản thương hiệu và báo chí",
    "mediaKit.seoDescription":
      "Tài sản thương hiệu, sản phẩm và báo chí chính thức của LUKKEY cho truyền thông, đối tác và các ấn phẩm bên ngoài được phê duyệt.",
    "mediaKit.badge": "Media kit",
    "mediaKit.heroTitle": "Sẵn sàng khi cần.",
    "mediaKit.heroSubtitle": "Logo. Hình sản phẩm. Tệp báo chí.",
    "mediaKit.allAssets": "Tất cả tài sản",
    "mediaKit.pickOne": "Chọn một",
    "mediaKit.files": "tệp",
    "mediaKit.fileCount": "{{count}} tệp",
    "mediaKit.modules": "{{count}} mô-đun",
    "mediaKit.chooseAssets": "Chọn tài sản cần dùng.",
    "mediaKit.download": "Tải xuống",
    "mediaKit.directoryLabel": "Thư mục tệp",
    "mediaKit.showDirectory": "Xem thư mục tệp",
    "mediaKit.closeDirectory": "Đóng thư mục tệp",
    "mediaKit.noDirectoryFiles": "Chưa có tệp nào được liệt kê.",
    "mediaKit.filesPending": "Tệp đang chuẩn bị",
    "mediaKit.empty": "Các tệp media kit đang được chuẩn bị.",
    "mediaKit.module.brand-logos.title": "Yếu tố thương hiệu",
    "mediaKit.module.product-images.title": "Hình sản phẩm",
    "mediaKit.module.brand-documents.title": "Tài liệu thương hiệu",
  },
  id: {
    "mediaKit.seoTitle": "Media kit LUKKEY | Aset merek dan desain",
    "mediaKit.seoDescription":
      "Aset resmi merek, produk, desain, dan dokumen LUKKEY untuk mitra dan publikasi eksternal yang disetujui.",
    "mediaKit.badge": "Media kit",
    "mediaKit.heroTitle": "Siap saat dibutuhkan.",
    "mediaKit.heroSubtitle": "Logo. Gambar produk. Dokumen merek.",
    "mediaKit.allAssets": "Semua aset",
    "mediaKit.pickOne": "Pilih satu",
    "mediaKit.files": "berkas",
    "mediaKit.fileCount": "{{count}} berkas",
    "mediaKit.modules": "{{count}} modul",
    "mediaKit.chooseAssets": "Pilih aset Anda.",
    "mediaKit.download": "Unduh",
    "mediaKit.directoryLabel": "Direktori berkas",
    "mediaKit.showDirectory": "Tampilkan direktori berkas",
    "mediaKit.closeDirectory": "Tutup direktori berkas",
    "mediaKit.noDirectoryFiles": "Belum ada berkas yang tercantum.",
    "mediaKit.filesPending": "Berkas sedang disiapkan",
    "mediaKit.empty": "Berkas media kit sedang disiapkan.",
    "mediaKit.module.brand-logos.title": "Elemen merek",
    "mediaKit.module.product-images.title": "Gambar produk",
    "mediaKit.module.brand-documents.title": "Dokumen merek",
  },
  tl: {
    "mediaKit.seoTitle": "LUKKEY Media Kit | Brand at design assets",
    "mediaKit.seoDescription":
      "Opisyal na brand, produkto, design, at documentation assets ng LUKKEY para sa partners at aprubadong external publishing.",
    "mediaKit.badge": "Media kit",
    "mediaKit.heroTitle": "Handa kapag kailangan.",
    "mediaKit.heroSubtitle": "Logos. Product images. Brand documents.",
    "mediaKit.allAssets": "Lahat ng assets",
    "mediaKit.pickOne": "Pumili",
    "mediaKit.files": "files",
    "mediaKit.fileCount": "{{count}} files",
    "mediaKit.modules": "{{count}} modules",
    "mediaKit.chooseAssets": "Piliin ang assets.",
    "mediaKit.download": "I-download",
    "mediaKit.directoryLabel": "File directory",
    "mediaKit.showDirectory": "Ipakita ang file directory",
    "mediaKit.closeDirectory": "Isara ang file directory",
    "mediaKit.noDirectoryFiles": "Wala pang nakalistang file.",
    "mediaKit.filesPending": "Inihahanda ang files",
    "mediaKit.empty": "Inihahanda ang media kit files.",
    "mediaKit.module.brand-logos.title": "Brand elements",
    "mediaKit.module.product-images.title": "Product images",
    "mediaKit.module.brand-documents.title": "Brand Documents",
  },
  bn: {
    "mediaKit.seoTitle": "LUKKEY মিডিয়া কিট | ব্র্যান্ড ও ডিজাইন অ্যাসেট",
    "mediaKit.seoDescription":
      "পার্টনার এবং অনুমোদিত বাহ্যিক প্রকাশনার জন্য LUKKEY-এর অফিসিয়াল ব্র্যান্ড, পণ্য, ডিজাইন ও ডকুমেন্টেশন অ্যাসেট।",
    "mediaKit.badge": "মিডিয়া কিট",
    "mediaKit.heroTitle": "প্রয়োজন হলেই প্রস্তুত।",
    "mediaKit.heroSubtitle": "লোগো। পণ্যের ছবি। ব্র্যান্ড ডকুমেন্ট।",
    "mediaKit.allAssets": "সব অ্যাসেট",
    "mediaKit.pickOne": "একটি বেছে নিন",
    "mediaKit.files": "ফাইল",
    "mediaKit.fileCount": "{{count}} ফাইল",
    "mediaKit.modules": "{{count}} মডিউল",
    "mediaKit.chooseAssets": "আপনার অ্যাসেট বেছে নিন।",
    "mediaKit.download": "ডাউনলোড",
    "mediaKit.directoryLabel": "ফাইল ডিরেক্টরি",
    "mediaKit.showDirectory": "ফাইল ডিরেক্টরি দেখুন",
    "mediaKit.closeDirectory": "ফাইল ডিরেক্টরি বন্ধ করুন",
    "mediaKit.noDirectoryFiles": "এখনও কোনো ফাইল তালিকাভুক্ত নেই।",
    "mediaKit.filesPending": "ফাইল প্রস্তুত হচ্ছে",
    "mediaKit.empty": "মিডিয়া কিট ফাইল প্রস্তুত করা হচ্ছে।",
    "mediaKit.module.brand-logos.title": "ব্র্যান্ড উপাদান",
    "mediaKit.module.product-images.title": "পণ্যের ছবি",
    "mediaKit.module.brand-documents.title": "ব্র্যান্ড ডকুমেন্ট",
  },
};
